import { Component, inject } from '@angular/core';
import {ActivatedRoute, Router, RouterLink, RouterOutlet } from '@angular/router';


@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],  
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent {
  title = 'shield';
  private router = inject(Router);
  

  ngOnInit(): void { 
    this.router.navigate(['/home']);  
   }

}
